import React from 'react';
import { Calculator, FileText, Shield, MessageCircle, ClipboardList } from 'lucide-react';
export function MechanismSection() {
  const deliverables = [{
    icon: <FileText className="h-8 w-8 text-charcoal" data-id="element-69" />,
    title: 'El Manual del Contratista Pro',
    desc: 'Guía paso a paso en PDF, directo al grano y sin palabras raras.'
  }, {
    icon: <Calculator className="h-8 w-8 text-charcoal" data-id="element-70" />,
    title: 'Método de Cálculo x Metro Cuadrado',
    desc: 'Plantilla actualizable para que la inflación no te coma la ganancia.'
  }, {
    icon: <Shield className="h-8 w-8 text-charcoal" data-id="element-71" />,
    title: 'Modelo de Contrato Corto',
    desc: 'Un papel simple para que no te estafen con los pagos ni te pidan cosas gratis.'
  }, {
    icon: <ClipboardList className="h-8 w-8 text-charcoal" data-id="element-72" />,
    title: 'Plantilla de Presupuesto',
    desc: 'Formato profesional listo para copiar, pegar y enviar por WhatsApp.'
  }, {
    icon: <MessageCircle className="h-8 w-8 text-charcoal" data-id="element-73" />,
    title: 'Guía de Manejo de Objeciones',
    desc: "Qué responder exactamente cuando el cliente te dice que sos 'muy caro'."
  }];
  return <section className="py-20 px-4 bg-cement-dark" data-id="element-74">
      <div className="max-w-4xl mx-auto" data-id="element-75">
        <div className="text-center mb-16" data-id="element-76">
          <span className="inline-block bg-charcoal text-amber font-heading font-bold px-4 py-1 uppercase tracking-widest text-sm mb-4 rounded-sm" data-id="element-77">
            La Solución
          </span>
          <h2 className="font-heading font-bold text-4xl md:text-6xl text-charcoal uppercase mb-6" data-id="element-78">
            El Método de "Caja Limpia"
          </h2>
          <p className="font-body text-xl text-stone-700 max-w-2xl mx-auto" data-id="element-79">
            Este no es un libro de arquitectura. Es un sistema financiero para
            el obrero. Vas a aprender a desglosar cada peso: separar el costo de
            los peones, la logística y tu ganancia de "Director de Obra".
          </p>
          <p className="font-body text-xl font-bold text-charcoal mt-4 max-w-2xl mx-auto bg-amber/30 p-2" data-id="element-80">
            Con este método, vos sabés exactamente cuánta plata limpia te queda
            antes de poner el primer ladrillo.
          </p>
        </div>

        <h3 className="font-heading font-bold text-3xl text-charcoal uppercase mb-8 border-b-4 border-charcoal pb-2 inline-block" data-id="element-81">
          ¿Qué te llevás hoy?
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-82">
          {deliverables.map((item, index) => <div key={index} className="bg-white p-6 border-2 border-charcoal shadow-hard rounded-sm flex gap-4 items-start" data-id="element-83">
              <div className="bg-amber p-3 rounded-sm border-2 border-charcoal shrink-0" data-id="element-84">
                {item.icon}
              </div>
              <div data-id="element-85">
                <h4 className="font-heading font-bold text-xl text-charcoal uppercase mb-2" data-id="element-86">
                  {item.title}
                </h4>
                <p className="font-body text-stone-600 text-lg" data-id="element-87">{item.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}